export const colorizeSequenceWithSpaceMonospace = (sequence) => {
    const colorMapping = {
        'A': 'green',
        'T': 'red',
        'G': 'orange',
        'C': 'blue',
        'N': 'gray',
        '-': 'black',
        // TALEN/ZFN: Spacer 内の欠失塩基（仕様書 §6.8）
        '|': 'black',
    };

    const coloredSequence = sequence.split('').map(char => {
        const color = colorMapping[char] || 'black'; // Default to black
        return `<span style="color: ${color}; font-family: Courier New, monospace;">${char}</span>`;
    }).join('');

    return coloredSequence;
};

export const splitAndAnnotateCumulativeColoredSpaced = (text, length = 50) => {
    const chunks = [];
    for (let i = 0; i < text.length; i += length) {
        chunks.push(text.substring(i, i + length));
    }

    const annotatedChunks = [];
    let cumulativeLength = 0;
    for (const chunk of chunks) {
        cumulativeLength += chunk.length;
        const coloredChunk = colorizeSequenceWithSpaceMonospace(chunk);
        annotatedChunks.push(`${coloredChunk} (${cumulativeLength})`);
    }
    return annotatedChunks;
};
